export const FILTER_HEIGHT = '32px';
export const POPOVER_FIELD_MINIMUM_WIDTH = '320px';
